import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MerchantStoreOnboardingComponent } from 'app/components/merchant/merchant-store-onboarding/merchant-store-onboarding.component';
import {
    ByMerchantRequestDto,
    GetMerchantPayoutAccountResponseDto,
    MerchantVerificationCheckEnum,
    PayoutAccountStatusEnum,
    PayoutAccountType,
    PayoutAccountTypeEnum,
    PayServiceTypeEnum,
    PayServiceTypeModel,
    WalletDetail,
    XpressUserRoleEnum
} from 'app/models';
import { AppDataService, MerchantService } from 'app/services';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'merchant-payment-details',
    templateUrl: './merchant-payment-details.component.html',
    styleUrls: ['./merchant-payment-details.component.scss'],
    providers: [MessageService]
})
export class MerchantPaymentDetailsComponent implements OnInit {
    public merchantId: number = 0;
    @Input()
    set _merchantId(value: number) {
        this.merchantId = value;
        if (this.merchantId > 0) {
            this.getMerchantPayoutAccounts();
            this.getMerchantVerificationCheckLists();
        }
    }

    public merchantUserId: number = 0;
    @Input()
    set _merchantUserId(value: number) {
        this.merchantUserId = value;
    }

    public showMerchantDetailPaymentSideBar: boolean = false;
    @Input()
    set _showMerchantDetailPaymentSideBar(value: boolean) {
        this.showMerchantDetailPaymentSideBar = value;
    }

    @Input() public merchantStoreOnboardingComponent!: MerchantStoreOnboardingComponent;

    @Output() changedShowMerchantDetailPaymentSideBarEmit = new EventEmitter<boolean>();
    changedShowMerchantDetailPaymentSideBar(increased: any) {
        this.changedShowMerchantDetailPaymentSideBarEmit.emit(increased);
    }

    constructor(private messageService: MessageService,
        private merchantService: MerchantService,
        public appData: AppDataService) {
        this.isMerchant = this.appData.isMerchant();
    }

    public loading: boolean = false;

    public payment: any = {};
    public payoutAccountTypeEnum = PayoutAccountTypeEnum;
    public payoutAccountTypes = PayoutAccountType.PayoutAccountTypeList;
    public walletDetails = WalletDetail.WalletDetailList;

    public payoutAccountStatusEnum = PayoutAccountStatusEnum;

    public isMerchant: boolean = false;
    public xpressUserRoleEnum = XpressUserRoleEnum;
    paymentMethods = PayServiceTypeModel.CommonPaymentMethods;
      payments: [GetMerchantPayoutAccountResponseDto] = [{
        MerchantId: 0,
        UsePaymayaAccount: false,
        PayoutAccountTypeId: PayoutAccountTypeEnum.None,
        AccountName: '',
        AccountNumber: '',
        RejectReason: '',
        PayServiceId: PayServiceTypeEnum.None,
        PayServiceName: ''
      }];

      ngOnInit() {
        this.getMerchantPayoutAccounts();
      }

    public getMerchantPayoutAccounts() {
        this.loading = true;
        const payload: ByMerchantRequestDto = {
            MerchantId: this.merchantId
        };
        this.merchantService.getMerchantPayoutAccounts(payload, this.messageService)
        .then(data => {
            if(!data?.Success || data?.Items == null){
               // this.hidePaymentGridViewEmit.emit(false);
                this.loading = false;
                return;
            }
            this.payments = data?.Items.map((x: GetMerchantPayoutAccountResponseDto) => ({
              MerchantId: x.MerchantId,
              UsePaymayaAccount: x.UsePaymayaAccount,
              PayoutAccountTypeId: x.PayoutAccountTypeId,
              AccountName: x.AccountName,
              AccountNumber: x.AccountNumber,
              RejectReason: x.RejectReason,
              PayServiceId: x.PayServiceId,
              PayServiceName: this.getPayServiceTypeName(x.PayServiceId)
            }));
            this.loading = false;
        })
        .catch(err => {
            this.loading = false;
            throw err;
        });
    }
    getPayServiceTypeName(payServiceType: PayServiceTypeEnum): string{
        return this.paymentMethods.find(x => x.value === payServiceType)?.name;
    }
    public questions: { name: string; question: string; checkId: MerchantVerificationCheckEnum; isChecked: boolean }[] = [
        {
            name: 'Is the address correct?', question: '',
            checkId: MerchantVerificationCheckEnum.IsTheAddressCorrect, isChecked: false
        },
        {
            name: 'Is the account number correct?', question: '',
            checkId: MerchantVerificationCheckEnum.IsThePhotoClearAndAccurate, isChecked: false
        },
    ];
    getMerchantVerificationCheckLists() {
        const dto = {
            MerchantId: this.merchantId,
            MerchantPayoutAccountId: this.merchantId
        };

        this.loading = true;

        this.merchantService.getMerchantVerificationCheckLists(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                const questions = this.questions;

                data.Items.forEach((item: any) => {
                    const findItem = questions.find((obj) => {
                        const result = obj.checkId === item.CheckId;
                        return result;
                    });

                    if (findItem !== undefined) {
                        const index = questions.indexOf(findItem);
                        questions[index].isChecked = item.IsChecked;
                    }
                });
                this.checkVerificationForContinue();
                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }
    checkVerificationForContinue() {
        let countIsChecked = 0;

        this.questions.forEach(q => {
            if (q.isChecked) {
                countIsChecked += 1;
            } else {
                countIsChecked -= (countIsChecked > 0) ? 1 : 0;
            }
        });
    }
    addOrUpdateMerchantVerificationCheckList(question: any) {
        const dto = {
            MerchantId: this.merchantId,
            MerchantPayoutAccountId: this.merchantId,
            CheckId: question.checkId,
            IsChecked: question.isChecked
        };

        this.merchantService.addOrUpdateMerchantVerificationCheckList(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    question.isChecked = false;
                    this.checkVerificationForContinue();
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Data has been updated' });
                this.checkVerificationForContinue();
            })
            .catch(err => {
                question.isChecked = false;
                this.checkVerificationForContinue();
                throw err;
            });
    }
    public approvedOrReject(payoutAccountStatus: PayoutAccountStatusEnum) {
        const dto = {
            MerchantId: this.merchantId,
            RejectReason: this.payment.RejectReason,
            PayoutAccountStatusId: payoutAccountStatus
        };

        this.merchantService.approvedOrRejectMerchantPayoutAccountStatus(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Data has been updated' });
                this.merchantStoreOnboardingComponent.getMerchantPayoutAccounts();
                this.changedShowMerchantDetailPaymentSideBar(false);
            });

    }

    cancel() {
        this.changedShowMerchantDetailPaymentSideBar(!this.showMerchantDetailPaymentSideBar);
    }
}
